import { render, staticRenderFns } from "./BaseComposeNotifyDialog.vue?vue&type=template&id=2ef39ac2&scoped=true&"
import script from "./BaseComposeNotifyDialog.vue?vue&type=script&lang=js&"
export * from "./BaseComposeNotifyDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseComposeNotifyDialog.vue?vue&type=style&index=0&id=2ef39ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef39ac2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef39ac2')) {
      api.createRecord('2ef39ac2', component.options)
    } else {
      api.reload('2ef39ac2', component.options)
    }
    module.hot.accept("./BaseComposeNotifyDialog.vue?vue&type=template&id=2ef39ac2&scoped=true&", function () {
      api.rerender('2ef39ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseComposeNotifyDialog.vue"
export default component.exports